import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8d346e0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "push-page" }
const _hoisted_2 = { class: "ws_common_operation ws_mb20" }
const _hoisted_3 = { class: "table" }

import { ref, onMounted } from 'vue'
import AdvancedQueryLayout from '@/components/advanced-query-layout'
import {
  alarmPushActionPage,
  alarmStrategyTreelist,
  alarmPushActionDelete,
} from '@/api'
import OperationButtonList from '@/components/operation-button-list'
import i18n from '@/i18n'
import PushActiveModal from './components/push-active-modal.vue'
import { debounce } from 'lodash'
import { CODE_ENUM, PAGE_SIZES } from '@/common'
import { msgbox } from '@/utils'
import { ElMessage, ElMessageBox } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const t = i18n.global.t

const advancedRef = ref()

const buttonList = [
  {
    type: 'edit',
    text: t('W_PUSH.btnEdit'),
  },
  {
    type: 'delete',
    text: t('W_PUSH.btnDel'),
  },
  {
    type: 'detail',
    text: t('W_PUSH.btnView'),
  },
]

const formInline = ref({
  pushName: '',
  triggerId: '',
})

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const tableData = ref([])

const tableLoading = ref(false)

const fetchList = async (queryData?: any) => {
  //   const keepAliveData = advancedRef.value.getKeepAliveData()
  const { data, reset } = queryData || {}

  if (typeof reset === 'boolean') {
    pageParams.value.curPage = 1
  }
  tableLoading.value = true

  const res: any = await alarmPushActionPage({
    ...pageParams.value,
    ...data,
    // ...keepAliveData,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === 0) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}

onMounted(() => {
  fetchList()
  queryStrategyOps()
})

const contactFormatter = ({ reachUserNames }: any) => {
  return (reachUserNames || []).join(',') || '-'
}

const triggerNameFormatter = ({ triggerInfos }: any) => {
  return (triggerInfos || []).map((item: any) => item.name).join(',')
}

const pushActionConf: any = ref({
  visible: false,
  data: {},
  view: false,
})

const createPushAction = () => {
  pushActionConf.value = {
    visible: true,
    data: {},
    view: false,
  }
}

const editPushAction = ({ id }: any) => {
  pushActionConf.value = {
    visible: true,
    data: {
      pushActionId: id,
    },
    view: false,
  }
}

const viewPushAction = ({ id }: any) => {
  pushActionConf.value = {
    visible: true,
    data: {
      pushActionId: id,
    },
    view: true,
  }
}

const strategyOps: any = ref([])
const queryStrategyOps = async (strategyName?: string) => {
  const res: any = await alarmStrategyTreelist()
  if (res?.code === CODE_ENUM.SUCCESS) {
    strategyOps.value = (res?.data || []).map((item: any) => {
      return {
        value: item.id,
        label: item.name,
      }
    })
  }
}

const toDelete = ({ id }: any) => {
  msgbox({
    tip: t('W_PUSH.delTip'),
    thenFn: () => handleDelete({ id }),
  })
}

const handleDelete = async ({ id }: any) => {
  const res: any = await alarmPushActionDelete({
    pushActionIds: [id],
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg)
  }

  fetchList()
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(AdvancedQueryLayout), {
      class: "advance-container",
      ref_key: "advancedRef",
      ref: advancedRef,
      model: formInline.value,
      onFetchList: fetchList,
      border: true,
      labelWidth: 110
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          prop: "pushName",
          label: _ctx.$t('W_PUSH.labelName')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formInline.value.pushName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.pushName) = $event)),
              clearable: "",
              placeholder: _ctx.$t('W_PUSH.enter'),
              class: "ws_select"
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          prop: "triggerId",
          label: _ctx.$t('W_PUSH.labelStrategy')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: formInline.value.triggerId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formInline.value.triggerId) = $event)),
              filterable: "",
              clearable: "",
              placeholder: _ctx.$t('W_PUSH.enter'),
              class: "ws_select"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(strategyOps.value, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          onClick: createPushAction,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('W_PUSH.titleNew')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          class: "ws_common_table",
          stripe: "",
          data: tableData.value
        }, {
          empty: _withCtx(() => [
            _createVNode(_component_el_empty, {
              description: _ctx.$t('W_MSG.noData')
            }, null, 8, ["description"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: _ctx.$t('W_PUSH.colName'),
              "show-overflow-tooltip": ""
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "triggerName",
              label: _ctx.$t('W_PUSH.colTriggerName'),
              "show-overflow-tooltip": "",
              formatter: triggerNameFormatter
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "contact",
              label: _ctx.$t('W_PUSH.colContact'),
              "show-overflow-tooltip": "",
              formatter: contactFormatter
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "operation",
              label: _ctx.$t('W_PUSH.colOperation')
            }, {
              default: _withCtx((scope) => [
                _createVNode(_unref(OperationButtonList), {
                  buttonList: buttonList,
                  scope: scope.row,
                  onOnEdit: editPushAction,
                  onOnDetail: viewPushAction,
                  onOnDelete: toDelete
                }, null, 8, ["scope"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, tableLoading.value]
        ]),
        _createVNode(_component_el_pagination, {
          class: "ws_mt50",
          "current-page": pageParams.value.curPage,
          "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((pageParams.value.curPage) = $event)),
          "page-size": pageParams.value.pageSize,
          "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageParams.value.pageSize) = $event)),
          "page-sizes": _unref(PAGE_SIZES),
          layout: "->, total, sizes, prev, pager, next, jumper ",
          total: total.value,
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
      ]),
      _createVNode(PushActiveModal, {
        visible: pushActionConf.value.visible,
        "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((pushActionConf.value.visible) = $event)),
        data: pushActionConf.value.data,
        view: pushActionConf.value.view,
        onSuccess: fetchList
      }, null, 8, ["visible", "data", "view"])
    ])
  ], 64))
}
}

})